import { cn } from "@/lib/utils";
import { FLOW_COLOR } from "./flowColors";
export const STAGE_BAR_KEYS = ["new", "booked", "inTransit", "onHold", "delivered"] as const;
export type StageBarKey = (typeof STAGE_BAR_KEYS)[number];
export type StageBarCounts = Record<StageBarKey, number>;
const HEIGHT_PX = {
  strip: 3,
  sm: 6,
  md: 10
} as const;
type Segment = {
  key: string;
  count: number;
  color: string;
};
const segmentsOf = (stages: StageBarCounts, behind: StageBarCounts) => STAGE_BAR_KEYS.flatMap<Segment>(stage => {
  const late = Math.min(behind[stage], stages[stage]);
  const onTime = stages[stage] - late;
  return [{
    key: `${stage}-behind`,
    count: late,
    color: FLOW_COLOR.behind
  }, {
    key: stage,
    count: onTime,
    color: FLOW_COLOR[stage]
  }].filter(segment => segment.count > 0);
});
export function StageBar({
  stages,
  behind,
  mode = "fill",
  unitPx = 10,
  size = "sm",
  label,
  className
}: {
  stages: StageBarCounts;
  behind: StageBarCounts;
  mode?: "fill" | "unit";
  unitPx?: number;
  size?: keyof typeof HEIGHT_PX;
  label?: string;
  className?: string;
}) {
  const segments = segmentsOf(stages, behind);
  const total = segments.reduce((sum, segment) => sum + segment.count, 0);
  if (total === 0) return null;
  return <div role="img" aria-label={label} data-stages={JSON.stringify(stages)} className={cn("flex overflow-hidden rounded-full", mode === "fill" && "w-full", className)} style={{
    height: HEIGHT_PX[size],
    gap: 2
  }} data-sentry-component="StageBar" data-sentry-source-file="StageBar.tsx">
            {segments.map(segment => <span key={segment.key} className="h-full shrink-0 rounded-full" style={{
      background: segment.color,
      ...(mode === "fill" ? {
        flexGrow: segment.count,
        flexBasis: 2
      } : {
        width: Math.max(2, segment.count * unitPx - 2)
      })
    }} />)}
        </div>;
}